import { useEffect } from 'react';
import { Recipe } from '../../api/Recipe';
import { subscribeToFavoriteRecipes } from '../../context/favoritesRealtime';

interface UseFavoriteRecipeRealtimeOptions {
  favoritesRef: React.RefObject<Recipe[]>;
  setCachedFavorites: (favorites: Recipe[]) => void;
}

const buildFavoriteRecipeSubscriptionOptions = ({
  favoritesRef,
  setCachedFavorites,
}: UseFavoriteRecipeRealtimeOptions): UseFavoriteRecipeRealtimeOptions => ({
  favoritesRef,
  setCachedFavorites,
});

const useFavoriteRecipeRealtime = ({
  favoritesRef,
  setCachedFavorites,
}: UseFavoriteRecipeRealtimeOptions): void => {
  useEffect(() => {
    const cleanup = subscribeToFavoriteRecipes(
      buildFavoriteRecipeSubscriptionOptions({
        favoritesRef,
        setCachedFavorites,
      })
    );
    return cleanup;
  }, [favoritesRef, setCachedFavorites]);
};

export default useFavoriteRecipeRealtime;
